import { useEffect, useState } from "react";
import Layout from "../../components/layouts/Layout";
import { Divider } from "antd";
import { useDispatch, useSelector } from "react-redux";
import toastr from "toastr";
import { client2 } from "../../operationalRequest";
import SetMonthlyCostComponent from "./SetMonthlyCostComponent";
import { setConfiguration } from "../../store/slice/userSlice";
import getUserProfile from "../../store/action/userAction";
import SelectNotificationChannel from "../notifications/SelectNotiticationChannel";
import ThemePresetSelector from "../../components/branding/theme/ThemePresetSelector";
import getThemePreset from "../../store/action/themeAction";
import BrandingLogoUploader from "../../components/branding/logo/BrandingLogoUploader";
import getMainLogo from "../../store/action/logoAction";

const Setting = () => {
    const dispatch = useDispatch();

    const { user, configuration } = useSelector((state: any) => state.user);
    const [loading, setLoading] = useState(false);

    const [initialNotificationPreferences, setInitialNotificationPreferences] =
        useState<Record<string, string[]>>({});

    useEffect(() => {
        dispatch<any>(getUserProfile());
        dispatch<any>(getThemePreset());
    }, [dispatch]);

    const { theme } = useSelector((state: any) => state.theme);
    const [initialTheme, setInitialTheme] =
        useState<Record<string, string>>(theme);

    useEffect(() => {
            if (theme) {
                setInitialTheme(theme);
            }
        }, [theme]);

    const fetchData = async () => {
        try {
            const notificationChannelsResponse = await client2.get(
                "api/notification-preferences",
            );

            if (notificationChannelsResponse.status === 200) {
                const fetchedPreferences =
                    notificationChannelsResponse.data.data
                        .notification_preferences;
                setInitialNotificationPreferences(fetchedPreferences);
            }
        } catch (e) {
            console.error("Error fetching data:", e);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleCostSet = async (values: any, form: any) => {
        try {
            if (loading) return;
            setLoading(true);
            const response = await client2.put(`api/configurations-update`, {
                key: "pv-cost-rate",
                value: values.value,
            });
            if (response.status === 200) {
                let conf = configuration.map((item: any) =>
                    item.key === "pv-cost-rate"
                        ? { ...item, value: values.value }
                        : item,
                );
                dispatch<any>(setConfiguration(conf));

                toastr.success("Cost set successfully!");
                // form.resetFields();
            }
        } catch (e: any) {
            console.log(
                "Error occurred: ",
                e.response ? e.response.data : e.message,
            );
            toastr.error("Failed to set monthly cost.");
        } finally {
            setLoading(false);
        }
    };

    const handleNotificationChannelSet = async (values: any, form: any) => {
        console.log(values, "this values");
        try {
            if (loading) return;
            setLoading(true);

            const response = await client2.post(
                `api/notification-preferences`,
                {
                    notification_preferences: values.notification_preferences,
                },
            );
            if (response.status === 200) {
                dispatch<any>(getUserProfile());
                toastr.success("Notification Channels set successfully!");
            }
        } catch (e: any) {
            console.log(
                "Error occurred: ",
                e.response ? e.response.data : e.message,
            );
            toastr.error("Failed to set notification channel");
        } finally {
            setLoading(false);
        }
    };

    const handleLogoSet = async ( values: any) => {
         try {
            if (loading) return;
            setLoading(true);

            const response = await client2.post(
                `api/branding/logo`,
                values.logoUrl,
            );
            if (response.status === 200) {
                dispatch<any>(getMainLogo());
                toastr.success("Logo set successfully!");
            }
        } catch (e: any) {
            console.log(
                "Error occurred: ",
                e.response ? e.response.data : e.message,
            );
            toastr.error("Failed to set logo");
        } finally {
            setLoading(false);
        }
    }

    const handleThemePresetSet = async (values: any, form: any) => {
        try {
            if (loading) return;
            setLoading(true);

            const response = await client2.post(
                `api/branding/update`,
                values.branding,
            );
            if (response.status === 200) {
                dispatch<any>(getThemePreset());
                toastr.success("Theme Preset set successfully!");
            }
        } catch (e: any) {
            console.log(
                "Error occurred: ",
                e.response ? e.response.data : e.message,
            );
            toastr.error("Failed to set theme preset");
        } finally {
            setLoading(false);
        }
    };
    return (
        <Layout title={"Settings"}>
            <div className="px-8">
                {["tenant", "support-tenant"].includes(user.role) && (
                    <>
                        <Divider orientation="left">Cost Rate</Divider>
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                flexWrap: "wrap",
                            }}
                        >
                            <div style={{ flex: 1, minWidth: "300px" }}>
                                <SetMonthlyCostComponent
                                    loading={loading}
                                    onSubmit={handleCostSet}
                                    initialValue={
                                        configuration?.find(
                                            (item: any) =>
                                                item.key === "pv-cost-rate",
                                        ) ?? { value: 1 }
                                    }
                                />
                            </div>
                        </div>
                    </>
                )}
                <Divider orientation="left">Notification</Divider>
                <div
                    style={{
                        display: "flex",
                        gap: "16px",
                        flexWrap: "wrap",
                    }}
                >
                    <div style={{ flex: 1, minWidth: "300px" }}>
                        <SelectNotificationChannel
                            loading={loading}
                            onSubmit={handleNotificationChannelSet}
                            initialValue={initialNotificationPreferences}
                        />
                    </div>
                </div>
                {(user?.role == 'tenant' || user?.role == 'superadmin') ? (
                    <>
                        <Divider orientation="left"> Branding </Divider>
                        <div className="max-w-2xl">
                            <BrandingLogoUploader loading={loading} onSubmit={handleLogoSet} />
                        </div>
                        <Divider orientation="left">  </Divider>
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                flexWrap: "wrap",
                            }}
                        >
                            <div style={{ flex: 1, minWidth: "300px" }}>
                                <ThemePresetSelector
                                    loading={loading}
                                    onSubmit={handleThemePresetSet}
                                    initialValue={initialTheme}
                                />
                            </div>
                        </div>
                    </> 
                ) : <></>}
            </div>
        </Layout>
    );
};
export default Setting;
